<template>
    <!--    This component shows advert starting from page 2 two-->
    <div class="adverts-in-search" :key="adType" :data-type="adType">

        <template v-if="adType === 'SolAds'">
            <component v-if="isDesktop" is="script" type="text/javascript" data-params="jsads">
                m3ads_system = 'Solads';
                m3ads_partnernumber = 916887;
                m3ads_mediatype = 1;
                m3ads_sectors = '2009';
                m3ads_numberadverts = 1;
                m3ads_imagewidth = 970;
                m3ads_imageheight = 250;
                m3ads_referrer = '{{ referer }}'
            </component>

            <component v-else is="script" type="text/javascript" data-params="jsads">
                m3ads_system = 'Solads';
                m3ads_partnernumber = 916887;
                m3ads_mediatype = 1;
                m3ads_sectors = '2009';
                m3ads_numberadverts = 1;
                m3ads_imagewidth = 300;
                m3ads_imageheight = 250;
                m3ads_referrer = '{{ referer }}'
            </component>

            <component is="script" type="text/javascript"
                       src="//cdn.feed.solads.media/resources/scripts/jsAds-1.4.min.js"></component>
        </template>

        <template v-else-if="adType === 'SusiLive'">
            <a v-if="isDesktop" href="https://guppy.link/click?ADR=EROBELLA-950x250" rel="nofollow">
                <img src="https://cdn3.erobella.com/pa/susi_live_desktop.jpeg" alt="" width="950" height="250">
            </a>

            <a v-else href="https://guppy.link/click?ADR=EROBELLA-300x250" rel="nofollow" class="text-center">
                <img src="https://cdn3.erobella.com/pa/susi_live_mobile.jpeg" alt="" width="300" height="250">
            </a>
        </template>

        <template v-else-if="adType === 'VisitX'">
            <iframe v-if="isDesktop" src="https://www.clistory.com/ib/VX/nhfxzhf/EB?w=52569"
                    style="border:0px #ffffff none;" name="ib_mod_vx" scrolling="no"
                    frameborder="0" marginheight="0px" marginwidth="0px" height="250px" width="970px"
                    allowfullscreen></iframe>

            <iframe v-else src="https://www.clistory.com/ib/VX/dhxzhnf/EB?w=52569" style="border:0px #ffffff none;"
                    name="ib_mod_vx" scrolling="no"
                    frameborder="0" marginheight="0px" marginwidth="0px" height="250px" width="300px"
                    allowfullscreen></iframe>
        </template>

        <template v-else-if="adType === 'JuicyAds'">
            <template v-if="isDesktop">
                <!--JuicyAds v2.0-->
                <iframe border="0" frameborder="0" marginheight="0" marginwidth="0" width="908px" height=270
                        allowtransparency="true" src="https://adserver.juicyads.com/adshow.php?adzone=1037324"></iframe>
                <!--JuicyAds END-->
            </template>

            <template v-else>
                <!--JuicyAds v2.0-->
                <iframe border="0" frameborder="0" marginheight="0" marginwidth="0" width="300px" height=262
                        allowtransparency="true" src="https://adserver.juicyads.com/adshow.php?adzone=1037325"></iframe>
                <!--JuicyAds END-->
            </template>
        </template>

        <template v-else-if="adType === 'StripChat'">
            <template v-if="isDesktop">
                <iframe width="970px" height="250px" style="display:block" marginWidth="0" marginHeight="0"
                        frameBorder="no" scrolling="no"
                        :src="`https://go.bluetrafficstream.com/smartpop/0d11d2306adff0b5a0bb3b59ce31bd6f1a01a4761d6137191458b8ff2a67621e?userId=c0decb93537301073993488b33966ddfb2295b3b0763ce4db2b422b4caae635b&sourceId=${stripChatSourceId}&campaignId=${stripChatCampaignId}`"></iframe>
            </template>

            <template v-else>
                <iframe width="300px" height="250px" style="display:block" marginWidth="0" marginHeight="0"
                        frameBorder="no" scrolling="no"
                        :src="`https://go.bluetrafficstream.com/smartpop/d586d5a04ffa6ce586073e951c301db14aeb1237857493c43785e72fd41d152a?userId=c0decb93537301073993488b33966ddfb2295b3b0763ce4db2b422b4caae635b&sourceId=${stripChatSourceId}&campaignId=${stripChatCampaignId}`"></iframe>
            </template>
        </template>

        <template v-else-if="adType === 'TrafficHunt'">
            <template v-if="isDesktop">
                <iframe width="970" height="250" frameborder="0" scrolling="no"
                        src="//ads.traffichunt.com/adx-dir-d/servlet/WebF_AdManager.AdDecision?aid=9946065&reqin=iframe&w=970&h=250&adpos=atf&nid=3&cb=&ref="
                        style="width:970px; height:250px;"></iframe>
            </template>
            <template v-else>
                <iframe width="300" height="250" frameborder="0" scrolling="no"
                        src="//ads.traffichunt.com/adx-dir-d/servlet/WebF_AdManager.AdDecision?aid=9946063&reqin=iframe&w=300&h=250&adpos=atf&nid=3&cb=&ref="
                        style="width:300px; height:250px;"></iframe>
            </template>
        </template>

        <template v-else-if="adType === 'exoclick'">
            <template v-if="isDesktop">
                <iframe src="//a.magsrv.com/iframe.php?idzone=5198294&size=900x250" width="900" height="250"
                        scrolling="no" marginwidth="0" marginheight="0" frameborder="0"></iframe>
            </template>
            <template v-else>
                <iframe src="//a.magsrv.com/iframe.php?idzone=5198296&size=300x250" width="300" height="250"
                        scrolling="no" marginwidth="0" marginheight="0" frameborder="0"></iframe>
            </template>
        </template>

        <template v-if="adType === 'bongocam'">
            <template v-if="isDesktop">
                <iframe scrolling="no" frameborder="0" width="970" height="250"
                        src="https://dynspt.com/promo.php?c=812590&type=dynamic_banner&new_banner=0&db%5Bwidth%5D=900&db%5Bheight%5D=250&db%5Btype%5D=live&db%5Bmodel_zone%5D=free&db%5Bheader%5D=1&db%5Bfooter%5D=none&db%5Bmlang%5D=0&db%5Bfullscreen%5D=&db%5Bmname%5D=1&db%5Bmlink%5D=1&db%5Bmstatus%5D=0&db%5Bmsize%5D=auto&db%5Bmpad%5D=16&db%5Bmwidth%5D=159&db%5Bcolor_scheme%5D=default&db%5Bmborder%5D=solid&db%5Bmborder_color%5D=%23ffffff&db%5Bmborder_over_color%5D=%23a02239&db%5Bmshadow%5D=0&db%5Bmodels_by_geo%5D=0&db%5Bautoupdate%5D=1&db%5Btopmodels%5D=1&db%5Blanding%5D=chat&db%5Blogo_color%5D=default&db%5Blogo_align%5D=left&db%5Bbg_color%5D=none&db%5Bfont_family%5D=Arial&db%5Btext_align%5D=center&db%5Btext_color%5D=%23000000&db%5Blink_color%5D=%23a02239&db%5Beffect%5D=auto&db%5Beffect_speed%5D=optimal&db%5Bmode%5D=mode1&db%5Badaptive%5D=1&db%5Bslider%5D=0&db%5Bchat%5D=0&db%5Bcategories%5D%5B%5D=curvy"></iframe>
            </template>
            <template v-else>
                <iframe scrolling="no" frameborder="0" width="300" height="250"
                        src="https://dynspt.com/promo.php?c=812589&type=dynamic_banner&new_banner=0&db%5Bwidth%5D=300&db%5Bheight%5D=250&db%5Btype%5D=live&db%5Bmodel_zone%5D=free&db%5Bheader%5D=1&db%5Bfooter%5D=footer_text_1&db%5Bmlang%5D=0&db%5Bfullscreen%5D=on&db%5Bmname%5D=1&db%5Bmlink%5D=1&db%5Bmstatus%5D=1&db%5Bmsize%5D=custom&db%5Bmpad%5D=0&db%5Bmwidth%5D=300&db%5Bcolor_scheme%5D=default&db%5Bmborder%5D=none&db%5Bmborder_color%5D=%23ffffff&db%5Bmborder_over_color%5D=%23a02239&db%5Bmshadow%5D=0&db%5Bmodels_by_geo%5D=0&db%5Bautoupdate%5D=1&db%5Btopmodels%5D=0&db%5Blanding%5D=chat&db%5Blogo_color%5D=default&db%5Blogo_align%5D=left&db%5Bbg_color%5D=%23eeeeee&db%5Bfont_family%5D=Arial&db%5Btext_align%5D=center&db%5Btext_color%5D=%23000000&db%5Blink_color%5D=%23a02239&db%5Beffect%5D=auto&db%5Beffect_speed%5D=optimal&db%5Bmode%5D=mode6&db%5Badaptive%5D=0&db%5Bslider%5D=0&db%5Bchat%5D=0"></iframe>
            </template>
        </template>

        <template v-if="adType === 'we-love-x'">
            <a v-if="isDesktop"
               href="https://www.top10-sextreffen.de/lpv2/mobile/?source=erbla&wlx3=erbla-de-mobile~1erbla~2~3~4erbla-banner~5&wlx=&adw-cpn=bann-m"
               rel="nofollow">
                <img src="https://cdn3.erobella.com/pa/sextreffen_desktop.gif" alt="" width="950" height="250">
            </a>

            <a v-else
               href="https://www.top10-sextreffen.de/lpv2/mobile/?source=erbla&wlx3=erbla-de-mobile~1erbla~2~3~4erbla-banner~5&wlx=&adw-cpn=bann-m"
               rel="nofollow" class="text-center">
                <img src="https://cdn3.erobella.com/pa/sextreffen_mobile.gif" alt="" width="300" height="250">
            </a>
        </template>

        <template v-if="adType === 'mychance-de'">
            <iframe v-if="isDesktop"
                    :src="regionRelativeUrl('https://cdnb-partner.erobella.com/myChance/900x250_de.html')" width="900"
                    height="250" style="border: none;" scrolling="no" marginwidth="0" marginheight="0"
                    frameborder="0"></iframe>
            <iframe v-else :src="regionRelativeUrl('https://cdnb-partner.erobella.com/myChance/300x250_de.html')"
                    width="300" height="250" style="border: none;" scrolling="no" marginwidth="0" marginheight="0"
                    frameborder="0"></iframe>
        </template>

        <template v-if="adType === 'mychance-at'">
            <iframe v-if="isDesktop"
                    :src="regionRelativeUrl('https://cdnb-partner.erobella.com/myChance/900x250_at.html')" width="900"
                    height="250" style="border: none;" scrolling="no" marginwidth="0" marginheight="0"
                    frameborder="0"></iframe>
            <iframe v-else :src="regionRelativeUrl('https://cdnb-partner.erobella.com/myChance/300x250_at.html')"
                    width="300" height="250" style="border: none;" scrolling="no" marginwidth="0" marginheight="0"
                    frameborder="0"></iframe>
        </template>

        <template v-if="adType === 'mychance-au'">
            <iframe v-if="isDesktop"
                    :src="regionRelativeUrl('https://cdnb-partner.erobella.com/myChance/900x250_au.html')" width="900"
                    height="250" style="border: none;" scrolling="no" marginwidth="0" marginheight="0"
                    frameborder="0"></iframe>
            <iframe v-else :src="regionRelativeUrl('https://cdnb-partner.erobella.com/myChance/300x250_au.html')"
                    width="300" height="250" style="border: none;" scrolling="no" marginwidth="0" marginheight="0"
                    frameborder="0"></iframe>
        </template>

        <template v-if="adType === 'cam4-de'">
            <template v-if="isDesktop">
                <iframe width="950" height="250"
                        src="https://landers.cam4.com/html_banner/?column=3&limit=6&gender=female&var8=200882&var9=erobella_de_html_950x250&campaign=805eeac5-2c34-4275-af95-64b026cb0ab8"
                        frameborder="0"></iframe>
            </template>
            <template v-else>
                <iframe width="300" height="250"
                        src="https://landers.cam4.com/html_banner/?gender=female&var8=200882&var9=erobella_de_html_300x250&campaign=805eeac5-2c34-4275-af95-64b026cb0ab8"
                        frameborder="0"></iframe>
            </template>
        </template>

        <template v-if="adType === 'cam4-at'">
            <template v-if="isDesktop">
                <iframe width="950" height="250"
                        src="https://landers.cam4.com/html_banner/?column=3&limit=6&gender=female&var8=200882&var9=erobella_at_html_950x250&campaign=4737b06a-a0f5-4416-b3eb-4811f6d69d32"
                        frameborder="0"></iframe>
            </template>
            <template v-else>
                <iframe width="300" height="250"
                        src="https://landers.cam4.com/html_banner/?gender=female&var8=200882&var9=erobella_at_html_300x250&campaign=4737b06a-a0f5-4416-b3eb-4811f6d69d32"
                        frameborder="0"></iframe>
            </template>
        </template>

        <template v-if="adType === 'livehdcams'">
            <template v-if="isDesktop">
                <iframe width="950" height="250"
                        src="https://creative.livehdcams.one/widgets/v4/Universal?autoplay=all&autoplayForce=1&titleText=Deutsche%20Sexcams&gridRows=1&gridColumns=4&responsive=0&hideButton=1&hideButtonOnSmallSpots=0&hideTitleOnSmallSpots=0&hideModelNameOnSmallSpots=0&sourceId=erobelGEpc&tag=girls%2Fgerman&userId=2e5a259f861addfb31a539234234156f2e412653e1e9e291caf829a5c53ceb9b"
                        frameborder="0"></iframe>
            </template>
            <template v-else>
                <iframe width="300" height="250"
                        src="https://creative.livehdcams.one/widgets/v4/Universal?autoplay=all&autoplayForce=1&titleText=Deutsche%20Sexcams&gridRows=2&gridColumns=2&responsive=0&hideButton=1&hideButtonOnSmallSpots=0&hideTitleOnSmallSpots=0&hideModelNameOnSmallSpots=0&sourceId=erobelGEmobile&tag=girls%2Fgerman&userId=2e5a259f861addfb31a539234234156f2e412653e1e9e291caf829a5c53ceb9b"
                        frameborder="0"></iframe>
            </template>

        </template>

        <template v-if="adType === 'traffickin'">
            <a v-if="isDesktop"
               href="https://pathtrkx.com/a0c5c395-78ce-4c10-858b-cbb7f9a6bb47?campid={cID}&varid=ITWEB1"
               target="_blank"
               rel="nofollow">
                <img src="https://cdn3.erobella.com/pa/tr/IT1WEB.svg" alt="" width="950" height="250">
            </a>

            <a v-else href="https://pathtrkx.com/a0c5c395-78ce-4c10-858b-cbb7f9a6bb47?campid={cID}&varid=ITMOB1"
               target="_blank"
               rel="nofollow" class="text-center">
                <img src="https://cdn3.erobella.com/pa/tr/IT1MOB.svg" alt="" width="300" height="250">
            </a>
        </template>
    </div>
</template>

<script>
import {getCountrySlug, regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";
import {StripChatSourceId} from "@/core/constants/advertConstants";

const data = () => {
    return {
        isDesktop: true,
    }
}

function created() {
    this.isDesktop = utils.isDesktop();
}

export default {
    methods: {regionRelativeUrl},
    data,
    created,
    computed: {
        referer() {
            return _.get(window, 'location.href', '');
        },
        stripChatCampaignId() {
            return getCountrySlug();
        },
        stripChatSourceId() {
            return StripChatSourceId.SEARCH_BANNER;
        },
    },
    props: {
        adType: {
            required: true,
            type: String,
        },
    },
}
</script>
